import { fromPromise } from "xstate";

import { type SearchUserResult } from "~/state/types";
import { querySearchUsers } from "~/utils/gitea";

import { authenticationActorRef, waitForAccessTokenSilently } from "../authentication";

export const searchUserActor = fromPromise(
	async ({ input }: { input: { query: string } }): Promise<SearchUserResult[]> => {
		if (input.query === "") {
			return [];
		}
		const accessToken = await waitForAccessTokenSilently(authenticationActorRef);
		const users = await querySearchUsers(accessToken!, input.query);
		return users;
	}
);
